import { useState, useEffect } from "react";
// import ClientSubcription from "./ClientSubcription";
// import './Managementor.css'; // Assuming this path is correct relative to Management3.js 
import { Link } from "react-router-dom"; // Importing Link for navigation all the regodring of the code not useful inthe acupied of the reginal code thats not equally happed in the registration process of the procedures 
import EventPaidClents from "./EventPaidClents";
import Eventsubscribedclients from "./Eventsubscribedclients";
import Eventenquery from "./Eventenquery";
import "./Eventclientmanagment.css";
const Eventclient = () => {
    const [activeTab, setActiveTab] = useState("Enquiry");
    const tabContent = {
        "Enquiry": <Eventenquery />,
        "Registration": <EventPaidClents />,
        "Subscribed": <Eventsubscribedclients />,


    };

    
    const activeTabStyle = { backgroundColor: '#b15cd6', color: '#fff', borderRadius: '10px', height: '40px', border: 'none' };
    const inactiveTabStyle = { backgroundColor: '#d9d9d9', color: '#000', borderRadius: '10px', height: '40px', border: 'none' };

    return (
        <div className="container-fluid p-0 client-managment-data">
            <div className="row g-0" style={{ marginTop: '90px', height: "92vh", }}>


                {/* Main Content Area */}
                <div className="col-lg-2"></div>
                <div className="col-lg-10 "> {/* Changed from col-lg-10 to take full width if no sidebar or manage sidebar externally */}
                    <p
                        className="breadcrumb maamaas-home-bredcum or22"
                        style={{
                            position: "fixed",
                            top: "59px",
                            left: "1vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            padding: "10px 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        <Link
                            to="/Homes"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link>

                        <span className="separator"> &gt; </span>


                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Client_Management
                        </span>
                        <span className="separator"> &gt; </span>


                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Events
                        </span>
                    </p>
                    {/* Tab Buttons Container - Positioned with margin, does NOT scroll */}
                    <div className="sticky-top py-1 px-1" style={{ top: '66px' /* Adjust if you have a fixed navbar higher up */ }}>
                        {/* The 'marginTop: "135px"' from original code is complex if not part of a fixed header.
                 For a simpler Bootstrap approach, if buttons are above scrollable content,
                 they can be part of the normal flow or made sticky. Here, making them sticky.
                 If you have a main navbar, adjust 'top' value.
             */}
                        <div className="row g-2 justify-content-center justify-content-sm-evenly">
                            {Object.keys(tabContent).map((label) => (
                                <div className="col-auto" style={{ minWidth: '100px' }} key={label}> 
                                    <button
                                        onClick={() => setActiveTab(label)}
                                        style={{
                                            border: "none",
                                            borderRadius: "10px",
                                            minWidth: "140px",
                                            width: "100%",
                                            padding: "0 10px",
                                            height: "40px",
                                            backgroundColor: activeTab === label ? "#b15cd6" : "#d9d9d9",
                                            color: activeTab === label ? "#fff" : "#000",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            transition: "background-color 0.3s ease",
                                            fontSize: "1rem",
                                        }}
                                    >
                                        {label}
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>

                    
                    <div
                        style={{
                            height: `calc(100vh - 75px - 60px)`, 
                            overflowY: "auto",
                            scrollbarWidth: "none", 
                        }}
                        className="" 
                    >
                        
                        <style>{`
              div::-webkit-scrollbar { 
                display: none; 
              }
            `}</style>
                        {tabContent[activeTab]}
                    </div>
                </div>
            </div>
        </div>
    );
};
const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
};


const evenRowStyle = { backgroundColor: "#fff" };
const oddRowStyle = { backgroundColor: "#f7f7f7" };

export default Eventclient;